require('initializers/gettext').default(__TRANSLATIONS__.gettext.es); // eslint-disable-line no-undef
require('initializers/i18n').default('es', __TRANSLATIONS__.i18n.es); // eslint-disable-line no-undef

require('locales/dependencies');

require('select2/dist/js/i18n/es');
require('jquery-ui/ui/i18n/datepicker-es');
require('dayjs/locale/es');
